import { useCallback, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../context/user-context';

const calendarHost = 'calendar.sportomedia.se';

export const useCalendar = () => {
  const { getUser, getIdToken } = useContext(UserContext);

  const addMatchToCalendar = useCallback(
    async ({ id, leagueName, season, type }) => {
      const idToken = await getIdToken();
      if (idToken) {
        return axios
          .put(
            `https://${calendarHost}/add`,
            { id, leagueName, season, type },
            { headers: { Authorization: `Bearer ${idToken}` } }
          )
          .catch((err) => {
            console.error(err);
          });
      }
      return null;
    }
  );

  const addTeamToCalendar = useCallback(async ({ abbrv }) => {
    const idToken = await getIdToken();
    if (idToken) {
      return axios
        .put(`https://${calendarHost}/add/team/${abbrv}`, null, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
        .catch((err) => {
          console.error(err);
        });
    }
    return null;
  });

  const getUserCalendarUrl = useCallback(() => {
    const user = getUser();
    return user?.personId
      ? `webcal://${calendarHost}/user/${user.personId}`
      : null;
  });

  const getTeamCalendarUrl = useCallback((abbrv) => {
    return `webcal://${calendarHost}/team/${abbrv}`;
  });

  return {
    addMatchToCalendar,
    addTeamToCalendar,
    getUserCalendarUrl,
    getTeamCalendarUrl,
  };
};
